module.exports = __webpack_public_path__ + "img/5f_r_kandagawa.9f634184.png";